
import {
    Button,
    Card,
    CardHeader,
    CardBody,
  } from "@chakra-ui/react";
 
  
  const InitialPage = ({ nextStep }) => {
    return (
        <Card p="12px" mx="auto" w={{ base: "90%", md: "70%", lg: "60%" }}>
          <CardHeader color="#2A3042" fontSize="24px" fontWeight="semibold">
          Send and receive texts from your landline number
          </CardHeader>
  
          <CardBody>
            <img src="/assets/img/Inca.jpg" alt="img"/>
            <br/>
                <i class="arrow right"> </i>No need to change anything with your phones!<br/>
                <i class="arrow right"> </i>Make life simpler for your customers - they can text or call the same number<br/>
                <i class="arrow right"></i>Easily text back from the inca app when customers text your landline number<br/>
            <br/>
            <p>Starting your free trial only takes 2-3 minutes, click next to start.</p>
            <Button
                 
                  bg="#576CD1"
                  color="white"
                  _hover={{ bg: "#576CD1" }}
                   onClick={nextStep}
                >
                  Next
                </Button>
          </CardBody>
        </Card>
    );
  };
  
  export default InitialPage;
  